import { render, staticRenderFns } from "./CtaCta.vue?vue&type=template&id=0bf29fa6&scoped=true"
import script from "./CtaCta.vue?vue&type=script&lang=js"
export * from "./CtaCta.vue?vue&type=script&lang=js"
import style0 from "./CtaCta.vue?vue&type=style&index=0&id=0bf29fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf29fa6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/CtaCta.vue
// module id = 106
// module chunks = 0